import type { BackendModule } from "i18next";
import { normalizeLocale, type SupportedLocale } from "../lib/localeRoutes";

const catalogs = {
  en: () => import("./locales/en"),
  tr: () => import("./locales/tr"),
  de: () => import("./locales/de"),
  es: () => import("./locales/es"),
  ru: () => import("./locales/ru"),
  el: () => import("./locales/el"),
} satisfies Record<SupportedLocale, () => Promise<{ default: Record<string, object> }>>;

export const localeBackend: BackendModule = {
  type: "backend",
  init() {},
  read(language, namespace, callback) {
    const locale = normalizeLocale(language);
    // import() caches the locale chunk, even when several namespaces request it.
    void catalogs[locale]().then(
      ({ default: resources }) => callback(null, (resources as Record<string, object>)[namespace] ?? {}),
      (error: unknown) => callback(error instanceof Error ? error : new Error("Unable to load language"), false),
    );
  },
};
